"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var ObjectExpressionKeysTransformer_1;
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectExpressionKeysTransformer = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const estraverse = __importStar(require("@javascript-obfuscator/estraverse"));
const TObjectExpressionExtractorFactory_1 = require("../../types/container/node-transformers/TObjectExpressionExtractorFactory");
const IOptions_1 = require("../../interfaces/options/IOptions");
const IRandomGenerator_1 = require("../../interfaces/utils/IRandomGenerator");
const NodeTransformationStage_1 = require("../../enums/node-transformers/NodeTransformationStage");
const ObjectExpressionExtractor_1 = require("../../enums/node-transformers/converting-transformers/properties-extractors/ObjectExpressionExtractor");
const AbstractNodeTransformer_1 = require("../AbstractNodeTransformer");
const NodeGuards_1 = require("../../node/NodeGuards");
const NodeStatementUtils_1 = require("../../node/NodeStatementUtils");
let ObjectExpressionKeysTransformer = ObjectExpressionKeysTransformer_1 = class ObjectExpressionKeysTransformer extends AbstractNodeTransformer_1.AbstractNodeTransformer {
    constructor(objectExpressionExtractorFactory, randomGenerator, options) {
        super(randomGenerator, options);
        this.objectExpressionExtractorFactory = objectExpressionExtractorFactory;
    }
    static checkProhibitedPatterns(objectExpressionNode, objectExpressionHostNode) {
        const identifierNamesSet = new Set();
        let hasReferencedIdentifier = false;
        let hasCallExpression = false;
        let isInsideObjectExpression = false;
        estraverse.traverse(objectExpressionHostNode, {
            enter: (node) => {
                if (node === objectExpressionNode) {
                    isInsideObjectExpression = true;
                }
                if (isInsideObjectExpression && !hasCallExpression) {
                    if (NodeGuards_1.NodeGuards.isCallExpressionNode(node) || NodeGuards_1.NodeGuards.isNewExpressionNode(node)) {
                        hasCallExpression = true;
                    }
                }
                if (NodeGuards_1.NodeGuards.isIdentifierNode(node) || NodeGuards_1.NodeGuards.isThisExpressionNode(node)) {
                    const identifierName = NodeGuards_1.NodeGuards.isIdentifierNode(node)
                        ? node.name
                        : ObjectExpressionKeysTransformer_1.thisIdentifierName;
                    if (!isInsideObjectExpression) {
                        identifierNamesSet.add(identifierName);
                    }
                    else if (identifierNamesSet.has(identifierName)) {
                        hasReferencedIdentifier = true;
                    }
                }
                if (hasReferencedIdentifier && hasCallExpression) {
                    return estraverse.VisitorOption.Break;
                }
            },
            leave: (node) => {
                if (node === objectExpressionNode) {
                    isInsideObjectExpression = false;
                    if (hasReferencedIdentifier || hasCallExpression) {
                        return estraverse.VisitorOption.Break;
                    }
                }
            }
        });
        return { hasReferencedIdentifier, hasCallExpression };
    }
    static isProhibitedObjectExpressionNode(objectExpressionNode, objectExpressionParentNode, objectExpressionHostStatement) {
        if (ObjectExpressionKeysTransformer_1.isProhibitedArrowFunctionExpression(objectExpressionNode, objectExpressionParentNode) ||
            ObjectExpressionKeysTransformer_1.isProhibitedSequenceExpression(objectExpressionNode) ||
            ObjectExpressionKeysTransformer_1.isProhibitedLoopBody(objectExpressionNode)) {
            return true;
        }
        const { hasReferencedIdentifier, hasCallExpression } = ObjectExpressionKeysTransformer_1.checkProhibitedPatterns(objectExpressionNode, objectExpressionHostStatement);
        return hasReferencedIdentifier || hasCallExpression;
    }
    static isProhibitedLoopBody(objectExpressionNode) {
        let currentNode = objectExpressionNode;
        while (currentNode) {
            const parentNode = currentNode.parentNode;
            if (!parentNode || parentNode === currentNode) {
                break;
            }
            const isNonBlockLoopBody = NodeGuards_1.NodeGuards.isLoopStatementNode(parentNode) &&
                parentNode.body === currentNode &&
                !NodeGuards_1.NodeGuards.isBlockStatementNode(currentNode);
            if (isNonBlockLoopBody) {
                return true;
            }
            if (NodeGuards_1.NodeGuards.isFunctionNode(parentNode) || NodeGuards_1.NodeGuards.isProgramNode(parentNode)) {
                break;
            }
            currentNode = parentNode;
        }
        return false;
    }
    static isProhibitedArrowFunctionExpression(objectExpressionNode, objectExpressionNodeParentNode) {
        return (NodeGuards_1.NodeGuards.isArrowFunctionExpressionNode(objectExpressionNodeParentNode) &&
            objectExpressionNodeParentNode.body === objectExpressionNode);
    }
    static isProhibitedSequenceExpression(objectExpressionNode) {
        const parentNode = objectExpressionNode.parentNode;
        if (!parentNode) {
            return false;
        }
        if (NodeGuards_1.NodeGuards.isSequenceExpressionNode(parentNode)) {
            const index = parentNode.expressions.indexOf(objectExpressionNode);
            return index > 0;
        }
        let currentNode = parentNode;
        while (currentNode.parentNode) {
            const currentParent = currentNode.parentNode;
            if (NodeGuards_1.NodeGuards.isSequenceExpressionNode(currentParent)) {
                const index = currentParent.expressions.indexOf(currentNode);
                if (index > 0) {
                    return currentParent.expressions.slice(0, index).some((expr) => {
                        let hasCall = false;
                        estraverse.traverse(expr, {
                            enter: (node) => {
                                if (NodeGuards_1.NodeGuards.isCallExpressionNode(node) ||
                                    NodeGuards_1.NodeGuards.isNewExpressionNode(node)) {
                                    hasCall = true;
                                    return estraverse.VisitorOption.Break;
                                }
                            }
                        });
                        return hasCall;
                    });
                }
                return false;
            }
            if (NodeGuards_1.NodeGuards.isFunctionNode(currentParent) ||
                NodeGuards_1.NodeGuards.isProgramNode(currentParent) ||
                NodeGuards_1.NodeGuards.isBlockStatementNode(currentParent)) {
                break;
            }
            currentNode = currentParent;
        }
        return false;
    }
    getVisitor(nodeTransformationStage) {
        if (!this.options.transformObjectKeys) {
            return null;
        }
        switch (nodeTransformationStage) {
            case NodeTransformationStage_1.NodeTransformationStage.Converting:
                return {
                    leave: (node, parentNode) => {
                        if (parentNode && NodeGuards_1.NodeGuards.isObjectExpressionNode(node)) {
                            return this.transformNode(node, parentNode);
                        }
                    }
                };
            default:
                return null;
        }
    }
    transformNode(objectExpressionNode, parentNode) {
        if (!objectExpressionNode.properties.length) {
            return objectExpressionNode;
        }
        const hostStatement = NodeStatementUtils_1.NodeStatementUtils.getRootStatementOfNode(objectExpressionNode);
        if (ObjectExpressionKeysTransformer_1.isProhibitedObjectExpressionNode(objectExpressionNode, parentNode, hostStatement)) {
            return objectExpressionNode;
        }
        return this.applyObjectExpressionKeysExtractorsRecursive(objectExpressionNode, hostStatement, 0);
    }
    applyObjectExpressionKeysExtractorsRecursive(objectExpressionNode, hostStatement, extractorIndex) {
        const objectExpressionExtractorNames = ObjectExpressionKeysTransformer_1.objectExpressionExtractorNames;
        if (extractorIndex >= objectExpressionExtractorNames.length) {
            return objectExpressionNode;
        }
        const objectExpressionExtractor = objectExpressionExtractorNames[extractorIndex];
        const { nodeToReplace, objectExpressionHostStatement: newObjectExpressionHostStatement, objectExpressionNode: newObjectExpressionNode } = this.objectExpressionExtractorFactory(objectExpressionExtractor).extract(objectExpressionNode, hostStatement);
        this.applyObjectExpressionKeysExtractorsRecursive(newObjectExpressionNode, newObjectExpressionHostStatement, extractorIndex + 1);
        return nodeToReplace;
    }
};
exports.ObjectExpressionKeysTransformer = ObjectExpressionKeysTransformer;
ObjectExpressionKeysTransformer.thisIdentifierName = 'this';
ObjectExpressionKeysTransformer.objectExpressionExtractorNames = [
    ObjectExpressionExtractor_1.ObjectExpressionExtractor.ObjectExpressionToVariableDeclarationExtractor,
    ObjectExpressionExtractor_1.ObjectExpressionExtractor.BasePropertiesExtractor
];
exports.ObjectExpressionKeysTransformer = ObjectExpressionKeysTransformer = ObjectExpressionKeysTransformer_1 = __decorate([
    (0, inversify_1.injectFromBase)(),
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.Factory__IObjectExpressionExtractor)),
    __param(1, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IRandomGenerator)),
    __param(2, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IOptions)),
    __metadata("design:paramtypes", [typeof (_a = typeof TObjectExpressionExtractorFactory_1.TObjectExpressionExtractorFactory !== "undefined" && TObjectExpressionExtractorFactory_1.TObjectExpressionExtractorFactory) === "function" ? _a : Object, typeof (_b = typeof IRandomGenerator_1.IRandomGenerator !== "undefined" && IRandomGenerator_1.IRandomGenerator) === "function" ? _b : Object, typeof (_c = typeof IOptions_1.IOptions !== "undefined" && IOptions_1.IOptions) === "function" ? _c : Object])
], ObjectExpressionKeysTransformer);
